import {useEffect, useState} from 'react'
import Style from './style'

const BottomSheet = ({
	isOpen,
	onClose,
	children,
	title,
	showCloseButton = true,
	footer,
}) => {
	const [isAnimating, setIsAnimating] = useState(false)

	useEffect(() => {
		if (isOpen) {
			setIsAnimating(true)
			// Prevent body scroll when bottom sheet is open
			document.body.style.overflow = 'hidden'
		} else {
			// Restore body scroll when bottom sheet is closed
			document.body.style.overflow = 'unset'
		}

		return () => {
			document.body.style.overflow = 'unset'
		}
	}, [isOpen])

	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) {
			onClose()
		}
	}

	const handleClose = () => {
		setIsAnimating(false)
		setTimeout(() => {
			onClose()
		}, 300) // Match animation duration
	}

	if (!isOpen) return null

	return (
		<Style.Overlay onClick={handleOverlayClick} isAnimating={isAnimating}>
			<Style.Container isAnimating={isAnimating}>
				{(title || showCloseButton) && (
					<Style.Header>
						{title && <Style.Title>{title}</Style.Title>}
						{showCloseButton && (
							<Style.CloseButton onClick={handleClose}>
								<Style.CloseIcon />
							</Style.CloseButton>
						)}
					</Style.Header>
				)}
				<Style.Content>{children}</Style.Content>
				{/* Footer */}
				{footer && <Style.Footer>{footer}</Style.Footer>}
			</Style.Container>
		</Style.Overlay>
	)
}

export default BottomSheet
